<dialog-wrapper 
  *ngIf="{ hasEntity: !!performerList.length || !!sponsorList.length || exhibitorList.length } as vars"
  [disabled]="false"
  [smallTitle]="true"
  [dialogTitle]="'Associated with'"
  [hideBottom]="true"
  [titleHeight]="40"
  [giveMeTwenty]="true"
  [dontGiveExtraSpacing]="true"
  [showClose]="true"
  (close)="dialogRef.close()"
>
  <search-bar #searchBar *ngIf="vars.hasEntity" [debounceTime]="50" [gray]="true" [placeholder]="'Search'" (keyword)="onSearchInput($event)"></search-bar>
  <ng-container [ngTemplateOutlet]="entityContainer"  *ngIf="!!data.includeAttendees"
    [ngTemplateOutletContext]="{ entities: attendeesToShow, hadEntity: !!attendeeList.length, type: 'attendees', submitterType: 'Attendee' }"></ng-container>
  <ng-container [ngTemplateOutlet]="entityContainer" 
    [ngTemplateOutletContext]="{ entities: performersToShow, hadEntity: !!performerList.length, type: 'performers', submitterType: 'Performer' }"></ng-container>
  <ng-container [ngTemplateOutlet]="entityContainer" 
    [ngTemplateOutletContext]="{ entities: sponsorsToShow, hadEntity: !!sponsorList.length, type: 'sponsors', submitterType: 'Sponsor' }"></ng-container>
  <ng-container [ngTemplateOutlet]="entityContainer" 
    [ngTemplateOutletContext]="{ entities: exhibitorsToShow, hadEntity: !!exhibitorList.length, type: 'exhibitors', submitterType: 'Exhibitor' }"></ng-container>
  <ng-container *ngIf="!!data.includeAssets" [ngTemplateOutlet]="entityContainer" 
    [ngTemplateOutletContext]="{ entities: assetsToShow, hadEntity: !!assetList.length, type: 'assets', submitterType: 'Asset' }"></ng-container>
  <ng-container *ngIf="!!data.includeResources" [ngTemplateOutlet]="entityContainer" 
    [ngTemplateOutletContext]="{ entities: resourcesToShow, hadEntity: !!resourceList.length, type: 'resources', submitterType: 'Resource' }"></ng-container>
</dialog-wrapper>

<ng-template #entityContainer let-entities="entities" let-hadEntity="hadEntity" let-type="type" let-submitterType="submitterType">
  <h5>{{ type }}</h5>
  <div class="grey-hint" *ngIf="!entities.length">
    <ng-container *ngIf="!hadEntity">No {{ type }} in this event</ng-container>
    <ng-container *ngIf="hadEntity">No results</ng-container>
  </div>
  <toggle-button [selected]="data.selectedId === entity.id" *ngFor="let entity of entities; trackBy: trackByEntity" (select)="selectEntity(entity.id, submitterType)">
    <performer-card *ngIf="type === 'performers'" [performer]="entity"></performer-card>
    <asset-card *ngIf="type === 'assets'" [asset]="entity" ></asset-card>
    <sponsor-card *ngIf="type !== 'performers' && type !== 'assets'" [hidePhoto]="true" [sponsor]="entity"></sponsor-card>
  </toggle-button>
</ng-template>